export const orderContant = {
    delivery: {
        fast: 'fast',
        standard: 'standard'
    },
    payment: {
        later_money: 'Pay later',
        paypal: 'Paypal'
    }
}